import merge from 'lodash/merge'

import {
	FETCH_ROOM_RATE_DETAILS_BEGIN,
	FETCH_ROOM_RATE_DETAILS_SUCCESS,
	FETCH_ROOM_RATE_DETAILS_FAILURE
} from '../actions/fetchRoomRateDetails'

const initialState = {
	loading: false,
	error: null
}

export default function fetchRoomRateDetailsReducers(state = initialState, action) {
	switch(action.type) {
		case FETCH_ROOM_RATE_DETAILS_BEGIN:
			return {
				...state,
				loading: true,
				error: null
			}

		case FETCH_ROOM_RATE_DETAILS_SUCCESS:
			return {
				...state,
				loading: false,
				roomRateDetails: merge({}, state.roomRateDetails, action.payload)
			}

		case FETCH_ROOM_RATE_DETAILS_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload.error,
				roomRateDetails: [],
			}

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/fetchRoomRateDetailsReducers.js